import Vue from "vue";
import Loading from "./index.vue";
const loadingVueConstructor = Vue.extend(Loading);
// const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
// const MOZ_HACK_REGEXP = /^moz([A-Z])/;
// const camelCase = function(name) {
//   return name
//     .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
//       return offset ? letter.toUpperCase() : letter;
//     })
//     .replace(MOZ_HACK_REGEXP, "Moz$1");
// };
const getStyle = function(element, styleName) {
  if (!element || !styleName) return null;
  // styleName = camelCase(styleName);
  if (styleName === "float") {
    styleName = "cssFloat";
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, "");
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};
let instance = null;
Vue.directive("loading", {
  bind: function(el, binding, vnode) {
    instance = new loadingVueConstructor({
      el: document.createElement("div"),
      data: {
        kioShow: binding.value
      }
    });

    el.appendChild(instance.$el);

    let style = el.style;
    Vue.nextTick(() => {
      const positon = getStyle(el, "position");
      if (!["relative", "fixed", "absolute"].includes(positon)) {
        el.style.position = "relative";
        el.style.overflow = "hidden";
      }
    });
  },

  update: function(el, binding, vnode) {
    instance.kioShow = binding.value;
  },

  unbind: function(el, binding) {
    // el.remove(instance.$el);
    // instance = null;
  }
});
